import loading from './loading'
import message from './message'

export default {
    loading, 
    message
}